import { render } from "./badge.vue?vue&type=template&id=11c385b2&scoped=true"
import script from "./badge.vue?vue&type=script&lang=js"
export * from "./badge.vue?vue&type=script&lang=js"

import "./badge.vue?vue&type=style&index=0&id=11c385b2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11c385b2"],['__file',"src/js/components/badge.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "11c385b2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('11c385b2', __exports__)) {
    api.reload('11c385b2', __exports__)
  }
  
  module.hot.accept("./badge.vue?vue&type=template&id=11c385b2&scoped=true", () => {
    api.rerender('11c385b2', render)
  })

}


export default __exports__